<template>
    <div class="checkbox-button-label"
         :class="checkboxClasses"
         :id="uniqueId(id)"
         @click="onChange"
    >
        <div class="img-container">
            <div class="tick"></div>
        </div>
        <div class="text" v-if="htmlTitle" v-html="title">
        </div>
        <div class="text" v-if="!htmlTitle && title" :style="{'width': titleWidth + 'px'}">
            {{title}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckBox",
        props: {
            chosen: Boolean,
            partiallyFill: Boolean,
            titleWidth: {
                type: Number,
                required: false
            },

            id: {
                type: String,
                required: false,
                default: ''
            },
            title: {
                type: String,
                required: false,
                default: ''
            },
            htmlTitle: {
                type: Boolean,
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },

            mode: {
                type: Array,
                required: false,
                default: () => [],
            },
        },

        computed: {
            checkboxClasses() {
                return {
                    'checkbox-button-label_checked': this.chosen,
                    'checkbox-button-label_partial': this.partiallyFill,
                    'checkbox-button-label_dark': this.modeExists('dark'),
                    'checkbox-button-label_exportbase': this.modeExists('exportbase'),
                    'checkbox-button-label_aligntop': this.modeExists('aligntop'),
                    'checkbox-button_disabled': this.modeExists('disabled')
                }
            }
        },

        methods: {
            onChange () {
                if (!this.disabled) {
                    this.$emit('change', this.id);
                }
            },
            modeExists(mode) {
                return (this.mode.indexOf(mode) !== -1);
            },
            uniqueId(id) {
                return id.toString() + '_' + Math.random().toString(36).substr(2);
            }
        }
    }
</script>

<style scoped>
    .checkbox-button-label {
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        line-height: 17px;
        cursor: pointer;
    }
    .checkbox-button-label_aligntop {
        align-items: flex-start;
    }

    .img-container {
        display: inline-block;
        min-width: 16px;
        height: 16px;
    }

    .tick {
        display: inline-block;
        position: absolute;
        background-image: url("../assets/light_checkbox.png");
        background-position: 0 0;
        background-size: 16px;
        background-repeat: no-repeat;
        width: 16px;
        height: 16px;
    }

    .text {
        display: inline-block;
        margin-left: 10px;
        word-break: break-word;
    }

    .checkbox-button-label_checked .tick {
        background-position: 0 -34px;
    }
    .checkbox-button-label_partial .tick {
        background-position: 0 -17px;
    }
    .checkbox-button-label_dark .tick {
        background-image: url("../assets/dark_checkbox.png");
    }

    .checkbox-button-label_exportbase .text {
        margin-left: 5px;
        padding: 3px 5px;
        background: transparent;
    }
    .checkbox-button-label_exportbase.checkbox-button-label_checked .text {
        background-color: #91AD2C;
        color: #fff;
    }
    .checkbox-button_disabled {
        opacity: 0.5;
        cursor: default;
    }
</style>
